import {Directive, AfterViewInit, ElementRef, Renderer2, Inject} from '@angular/core';
import {AbsResponsiveRowComponent} from './abs-responsive-row.component';

@Directive({
    selector: '[abs-summary-table]'
})

export class AbsSummaryTableDirective implements AfterViewInit {
    constructor(
        @Inject(ElementRef) private element: ElementRef,
        @Inject(Renderer2) private renderer: Renderer2,
        @Inject(AbsResponsiveRowComponent) private responsiveRow: AbsResponsiveRowComponent) {
    }
    ngAfterViewInit() {
        if (this.responsiveRow && typeof this.responsiveRow.rowData === 'string') {
            this.responsiveRow.setSummaryContentValue(this.element.nativeElement.innerHTML);
        } else {
            if (this.element.nativeElement.innerText !== '') {
                this.responsiveRow.setSummaryContentValue(this.element.nativeElement.innerText);
            } else {
                var tdArray = this.element.nativeElement.parentElement.querySelectorAll('td')
                for (let i = 0; i < tdArray.length; i++) {
                    if (tdArray[i].getAttribute('abs-summary-table') !== null) {
                        this.responsiveRow.setSummaryContentValue(this.responsiveRow.rowData[i]);
                    }
                }
            }
        }
        this.renderer.removeChild(this.element.nativeElement.parentElement,this.element.nativeElement);
    }
}